import cn from "@/lib/cn";
import { ICON_THEME_COLOR, IconTheme } from "@/components/icons/theme";

export type IconCaretButtonRightProps = {
  theme?: IconTheme;
  style?: "filled" | "outline";
  className?: string;
  title?: string;
};

interface IconCaretButtonRightSvgProps {
  className?: string;
  title?: string;
}

const THEME_COLOR = ICON_THEME_COLOR;

function DefaultSvg({ className, title }: IconCaretButtonRightSvgProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      role={title ? "img" : "presentation"}
      aria-label={title}
      className={className}
    >
      <polygon points="9.93 18.74 8.19 17 13.22 11.99 8.19 6.97 9.93 5.24 16.69 11.99 9.93 18.74"></polygon>
    </svg>
  );
}

function OutlineSvg({ className, title }: IconCaretButtonRightSvgProps) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      role={title ? "img" : "presentation"}
      aria-label={title}
      className={className}
    >
      <path d="M7.02002 11.0134L6.31335 10.3067L8.62669 7.99339L6.31335 5.68672L7.02002 4.97339L10.04 7.99339L7.02002 11.0134Z" />
    </svg>
  );
}

export default function IconCaretButtonRight({
  theme = "black",
  style = "filled",
  className,
  title,
}: IconCaretButtonRightProps) {
  const themeClassname = THEME_COLOR[theme];
  const Variant = style === "outline" ? OutlineSvg : DefaultSvg;

  return <Variant title={title} className={cn(className, themeClassname)} />;
}
